import PropTypes from 'prop-types';
import { Box, Dialog, makeStyles, Divider, withStyles, Button, Theme, createStyles } from '@material-ui/core';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import { Loading, UploadLoading } from '../commonLoadings';
import { useEffect, useRef } from 'react';

const styles = (theme: Theme) =>
  createStyles({
    root: {
      margin: 0,
      padding: theme.spacing(2),
      paddingTop: 26
    },
    closeButton: {
      position: 'absolute',
      right: theme.spacing(1),
      top: theme.spacing(1),
      color: theme.palette.grey[500],
    },
    header: {
      color: '#606B76',
      fontFamily: 'Spartan-bold',
      fontSize: 24,
      paddingLeft: 17,
      paddingBottom: 7,
    }
  });

const useStyles = makeStyles(() => ({
  root: {},
  paper: {
    borderRadius: '24px!important'
  },
  description: {
    color: '#697683',
    fontSize: 14,
    lineHeight: 1.5,
    fontFamily: 'roboto-regular'
  },
  btnOK: {
    height: 37,
    padding: '0 18px',
    borderRadius: 6,
    background: '#017AEF',
    color: '#fff',
    textTransform: 'none',
    fontSize: 14,
    '&:hover': {
      background: '#0f9fef',
      color: '#fff',
    },
    '@media screen and (max-width: 600px)': {
      fontSize: 12,
      padding: '0 5px',
    }
  },
  btnCancel: {
    padding: '0 18px',
    height: 37,
    borderRadius: 6,
    background: '#F0F0F0',
    color: '#697683',
    textTransform: 'none',
    fontSize: 14,
    '&:hover': {
      background: '#e2e2e2',
      color: '#697683',
    },
    marginRight: 12,
    '@media screen and (max-width: 600px)': {
      fontSize: 12,
      padding: '0 5px',
    }
  },
  createReelTitle:{
    paddingTop:'26px !important',
    paddingBottom: '12px !important'

  }
}));

const DialogTitle = withStyles(styles)((props: any) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <div className={classes.header}>{children}</div>
      {onClose ? (
        <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
          <CloseIcon style={{ fontSize: 30 }} />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

function ImmersionModal({
  open,
  size,
  title,
  parent,
  description,
  onClose,
  onApply,
  titleOK,
  additional,
  loading,
  cancelDisable,
  okDisable,
  buttonDisable,
  titleCancel,
  disabled,
  focused,

  ...rest
}: any) {

  const classes = useStyles();
  const btnRef: any = useRef(null);

  useEffect(() => {
    setTimeout(() => {
      if(btnRef && btnRef.current && !focused){
        btnRef.current.focus();
      }
    }, 1000)
  }, [open, focused]);

  return (
      <Dialog
        fullWidth={true}
        maxWidth={size ? size : 'xs'}
        onClose={onClose}
        open={open}
        classes={{
          root: classes.root,
          paper: classes.paper
        }}
      >
        <div {...rest} className={parent === 'createReel' && 'create_reel_model'} >
          <DialogTitle  onClose={onClose}>
            {title}
          </DialogTitle>

          <Divider />

          {description && <Box m={4} mb={0} mt={1} pl={1} pr={1}>
            <p className={classes.description}>
              {description}
            </p>
          </Box>}

          <Box ml={5}>
            {additional}
          </Box>

          {!buttonDisable && (
            <div style={{ minHeight: 70 }}>
              {loading 
              ? title.includes('Uploading Video...')
                ? <UploadLoading />
                : <Loading style={{ width: 60, height: 25 }} />
              : <>
                <Box mt={3} mb={3} mr={2} display='flex' justifyContent='flex-end'>
                  {!cancelDisable &&
                    <Button onClick={onClose} color='primary' size='large' className={classes.btnCancel}>
                      {titleCancel ? titleCancel : 'Cancel'}
                    </Button>}
                  {!okDisable && <Button ref={btnRef} onClick={onApply} color='primary' size='large' className={classes.btnOK} disabled={disabled} style={{background: disabled ? '#ccc' : '#017AEF'}}>
                    {titleOK}
                  </Button>}
                </Box>
              </>}
            </div>
          )}

        </div>
      </Dialog>
  );
}

ImmersionModal.propTypes = {
  onClose: PropTypes.func,
  onApply: PropTypes.func,
  open: PropTypes.bool.isRequired,
  title: PropTypes.string.isRequired,
  parent: PropTypes.string,
  titleCancel: PropTypes.string,
  description: PropTypes.string,
  size: PropTypes.string,
  titleOK: PropTypes.string,
  additional: PropTypes.object,
  loading: PropTypes.bool,
  cancelDisable: PropTypes.bool,
  okDisable: PropTypes.bool,
  disabled:PropTypes.bool,
  buttonDisable: PropTypes.bool,
  focused: PropTypes.bool
};

ImmersionModal.defaultProps = {
  onClose: () => { }
};

export default ImmersionModal;
